<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <b-row>
          <b-col cols="6">
            <span v-if="isUpdateForm">{{ $t('project_user.update_title') }}</span>
            <span v-else>{{ $t('project_user.create_title') }}</span>
          </b-col>
        </b-row>
      </div>
      <div v-if="spinners.contentIsLoading" class="text-center">
        <b-spinner type="grow" variant="primary"/>
      </div>
      <div v-else>
        <b-form-group :invalid-feedback="fErr('role')">
          <label>{{ $t('project_user.role') }}</label>
          <b-form-select :placeholder="$t('project_user.placeholders.role')"
            :class="{ 'is-invalid' : fErr('role') }" v-model="entity.role">
            <b-form-select-option v-for="role in roles" :key="role" :value="role">
              {{$dt(`projectRole.${role}`,role)}}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>
        <b-form-group :label="$t('project_user.user_id')">
          <treeselect :class="{ 'treeselect-error' : fErr('user_id') }"
            :placeholder="$t('project_user.placeholders.user_id')"
            :load-options="audocompleteUser" :async="true" :defaultOptions="true"
            v-model="entity.user_id"/>
          <span class="error-text">{{ fErr('user_id') }}</span>
        </b-form-group>
      </div>
      <div slot="footer">
        <b-button type="submit" variant="primary" :disabled="spinners.isSaving" @click="save()">
          <b-spinner v-if="spinners.isSaving" type="grow" small/>
          {{ $t('global.save') }}
        </b-button>
        <router-view :to="{ name: 'ProjectUsers' }">
          <b-button type="reset" variant="info" class="ml-2">
            {{ $t('global.cancel') }}
          </b-button>
        </router-view>
      </div>
    </b-card>
    <ProjectAuditLogs v-if="isUpdateForm && !!entity.user_id" :embedded="true" :user_id="entity.user_id"/>
  </div>
</template>

<script>
import merge from 'lodash.merge';
import Services from '@/services/index';
import { mapGetters, mapState } from 'vuex';

import Treeselect, { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import ProjectAuditLogs from '@/views/Administration/ProjectAuditLogs';

export default {
  mounted() {
    this.load();
  },
  data() {
    return {
      spinners: {
        contentIsLoading: false,
        isSaving: false,
      },
      roles: [],
      entity: this.value,
      errorMsg: this.errors,
    };
  },
  props: {
    // If id === null, form will be considered create form else update
    id: { type: Number, default: null },
    project_id: { type: Number, default: null },
    // if title == false to hide header, pass string to override default title
    title: { type: [String, Boolean], default: undefined },
    // pass errors from parent form if embedded
    errors: { type: Object, default() { return {}; } },
    // value is used both as DEFAULTs placeholder and for v-model
    value: {
      type: Object,
      default() {
        return {
          role: '',
          user_id: null,
          project_id: null,
        };
      },
    },
  },
  components: {
    Treeselect, ProjectAuditLogs
  },
  computed: {
    // embedded form will have value passed using v-model, we could also make a custom prop for checking this
    isEmbedded() { return this.$options.propsData.value !== undefined; },
    isUpdateForm() { return this.id !== null; },
    ...mapState('Auth', ['activeProjectId']),
    ...mapGetters('Auth', ['projects']),
    projectId() { return this.project_id || this.activeProjectId; },
  },
  methods: {
    getForUpdate: Services.projectUsers.editData,
    getForCreate: Services.projectUsers.createData,
    pushUpdate: Services.projectUsers.update,
    pushCreate: Services.projectUsers.create,
    load() {
      this.spinners.contentIsLoading = true;
      const action = this.isUpdateForm ? this.getForUpdate : this.getForCreate;
      action(this.projectId, this.$route.params.id).then((data) => {
        this.spinners.contentIsLoading = false;
        this.entity = this.isUpdateForm ? data.data.projectUser : { ...this.entity, ...data.data.projectUser };
        this.roles = data.data.roles;
        // eslint-disable-next-line prefer-destructuring
        if (!this.roles.includes(this.entity.role) && this.roles.length > 0) this.entity.role = this.roles[0];
      }).catch((data) => {
        this.spinners.contentIsLoading = false;
        this.errorMsg = data.data ? data.data.errors : {};
      });
    },
    save() {
      if (this.isEmbedded) return;
      this.spinners.isSaving = true;
      const action = this.isUpdateForm ? this.pushUpdate : this.pushCreate;
      action(this.projectId, { ...this.entity, project_id: this.projectId }).then((data) => {
        this.spinners.isSaving = false;
        this.alertSuccess();
        // this.entity = data.data; // This wont work if entity has nested objects/forms
        merge(this.entity, data.data); // This will not delete keys but will preserve original object
        this.errorMsg = {};
        if (!this.isUpdateForm) {
          // After successful create
          // if (this.$can('edit', 'project_users')) {
          this.$router.push({ name: 'ProjectUserUpdate', params: { id: data.data.id } });
          // } else { // do not redirect if cannot edit
          //   this.entity = this.$options.props.value.default();
          //   this.load();
          // }
        }
      }).catch(({ errors, message }) => {
        this.spinners.isSaving = false;
        this.errorMsg = errors;
        this.alertError({ text: message });
      });
    },

    audocompleteUser({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        Services.users.list({ notpaginate: 1, search: searchQuery }).then(({ data }) => {
          const options = data.data.map((i) => ({
            id: i.id,
            label: `${i.id}: ${i.name} ${i.surname}`,
          }));
          callback(null, options);
        });
      }
    },
  }
};
</script>

<style scoped>
</style>
